import React from "react";
import baseStyles from "../../style.module.scss";
import styles from "./style.module.scss";
import getPricingDataById from "./utils/get-pricing-data-by-id";
import formatCurrency from "./utils/format-currency";
import formatPercentage from "./utils/format-percentage";
import PricingCard from "./components/shared/PricingCard";
import RateItem from "./components/shared/RateItem";
import useSalesFormStore from "../../../../../../../../stores/sales-form";

const ACH_FEES = [
  { key: 51, label: "Statement Fee" },
  { key: 52, label: "Monthly Minimum" },
  { key: 53, label: "Return Fee" },
  { key: 54, label: "NOC Fee" },
  { key: 55, label: "Unauthorized Return Fee" },
  { key: 56, label: "Same Day ACH Fee" },
  { key: 57, label: "Bank Account Validation Fee" },
];

const SectionHeader = ({ title }) => (
  <div className={baseStyles.sectionHeader}>
    <span className={baseStyles.sectionTitle}>{title}</span>
    <div className={baseStyles.sectionLine} />
  </div>
);

/**
 * ACH pricing and fees review block
 * @returns {React.ReactElement} Ach component
 */
const Ach = () => {
  const applicationData = useSalesFormStore((state) => state.applicationData);
  const achPricing = getPricingDataById(50, applicationData?.prices);

  return (
    <>
      <div className={baseStyles.section}>
        <PricingCard>
          <div className={styles.ratesList}>
            <RateItem
              label="Discount rate"
              value={formatPercentage(achPricing?.percent)}
            />
            <RateItem
              label="Transaction fee per item"
              value={formatCurrency(achPricing?.dollars)}
            />
          </div>
        </PricingCard>
      </div>

      <div className={baseStyles.section}>
        <SectionHeader title="Additional Fees" />
        <div className={styles.detailsGrid}>
          {ACH_FEES.map((fee) => (
            <div key={fee.key} className={baseStyles.detailItem}>
              <div className={baseStyles.detailLabel}>{fee.label}</div>
              <div className={baseStyles.detailValue}>
                {formatCurrency(
                  getPricingDataById(fee.key, applicationData?.prices)?.dollars,
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Ach;
